<template>
  <div>
    <Row :gutter="8" class="m-b-10">
      <i-col span="8">
        <i-input v-model="query.queryString" clearable size="small" placeholder="关键字：收款单名称"></i-input>
      </i-col>
      <i-col span="16">
        <Button type="primary" icon="ios-search" size="small" @click="handleSearch">搜索</Button>
        <i-button type="success" class="m-l-10" size="small" @click="handleCreate">新建收款单</i-button>
      </i-col>
    </Row>
    <Table stripe size="small" :data="tableData" :columns="tableColumns" :loading="tableLoading">
    </Table>
    <div class="paging_style">
      <Page size="small" :total="total" :page-size="query.pageSize" show-total show-elevator show-sizer
        :current="query.pageNumber" @on-change="handleChangePage" :page-size-opts="pagesizeSetting"
        @on-page-size-change='changePageSize'></Page>
    </div>

    <createDebtModal  ref="createDebtModal" @on-success="reloadTable"></createDebtModal>
  </div>
</template>

<script>
import createDebtModal from './CreateDebt.vue'

import { toMoney } from '@/utils/wnumb_own'
import { listDebt, delDebt } from '@/api/invest/debt'

export default {
  components: {
    createDebtModal
  },
  data () {
    return {
      pagesizeSetting: [15, 50, 100, 200, 500],
      query: {
        pageNumber: 1,
        pageSize: 15,
        queryString: ''
      },

      tableLoading: false,
      total: 0,
      tableData: [],
      tableColumns: [
        { title: '收款单名称', key: 'name' },
        { title: '付款单位', key: 'advertiserName' },
        {
          title: '周期',
          render: (h, params) => {
            return h('span', {}, `第 ${params.row.termNumber}期`)
          }
        },
        { title: '付款日期', key: 'lastDate' },
        {
          title: '收款单总额',
          key: 'total',
          width: 120,
          align: 'right',
          render: (h, params) => {
            return h('span', {},
              toMoney(params.row.amount))
          }
        },
        {
          title: '调差额',
          key: 'total',
          width: 120,
          align: 'right',
          render: (h, params) => {
            return h('span', {},
              toMoney(params.row.adjustAmount)
            )
          }
        },
        {
          title: '应付金额',
          key: 'amount',
          width: 150,
          align: 'right',
          render: (h, params) => {
            return h('strong', {
              attrs: {
                style: 'color:#44bd32'
              }
            },
            toMoney(params.row.amount + params.row.adjustAmount))
          }
        },
        {
          title: '状态',
          key: 'statusName',
          align: 'center',
          render: (h, params) => {
            if (params.row.status === 0) {
              return h('tag', { props: { color: 'default' } }, params.row.statusName)
            } else {
              return h('tag', { props: { color: 'green', type: 'border' } }, params.row.statusName)
            }
          }
        },
        {
          title: '操作',
          align: 'center',
          render: (h, params) => {
            const buttons = [
              h('a', {
                style: { marginRight: '10px' },
                on: {
                  click: () => {
                    this.$store.commit('set_receipt_pageType', 'detail')
                    this.$store.commit('set_receipt_receiptId', params.row.id)
                  }
                }
              }, '查看详情')
            ]

            if (params.row.status === 0) {
              buttons.push(h('a', {
                style: { color: '#ef4f4f' },
                on: {
                  click: () => {
                    this.confirmDeleteDebt(params.row.id)
                  }
                }
              }, '删除'))
            }

            return h('div', buttons)
          }
        }
      ]
    }
  },
  created () {
    this.initBaseData()
  },
  methods: {
    initBaseData () {
      this.tableLoading = true
      listDebt(this.query).then(res => {
        this.tableData = res.records
        this.total = res.total
        this.tableLoading = false
      })
    },
    handleSearch () {
      this.query.pageNumber = 1
      this.initBaseData()
    },
    reloadTable () {
      this.query.queryString = ''
      this.handleSearch()
    },
    handleChangePage (curPage) {
      this.query.pageNumber = curPage
      this.initBaseData()
    },
    changePageSize (pageSize) {
      this.query.pageNumber = 1
      this.query.pageSize = pageSize
      this.initBaseData()
    },

    handleCreate () {
      this.$refs.createDebtModal.showModal()
    },
    confirmDeleteDebt (debtId) {
      this.$Modal.confirm({
        title: '确定删除？',
        content: '<p>确定要删除该条数据，删除后将不可恢复！</p>',
        loading: true,
        onOk: () => {
          delDebt({ debtId }).then(res => {
            if (res && !res.errcode) {
              this.initBaseData()
              this.$Notice.success({ desc: '删除收款单成功。' })
            }
            this.$Modal.remove()
          }).catch(() => {
            this.$Modal.remove()
          })
        }
      })
    }
  }
}
</script>
